import { Auth0Provider } from '@auth0/auth0-react'
import { init } from '@sentry/react'
import Gleap from 'gleap'
import { createRoot } from 'react-dom/client'

// import _App from 'src/App'
import App_v2 from 'src/app'
import { APP_ENV } from 'src/env'

import './index.css'

// Sentry init
init({
    dsn: APP_ENV.REACT_APP_SENTRY_DSN,
    environment: APP_ENV.REACT_APP_ENVIRONMENT,
    enabled: APP_ENV.REACT_APP_LOCAL !== 'yes',
    integrations: [],
})

// Gleap Init
Gleap.initialize('zKR10CxrJ0LEBqv0EoqtqAlS9nBFtRRA')

/**
 * Always called post login
 */
const onRedirectCallback = (appState) => {
    if ('metadata' in appState) {
        localStorage.setItem(
            'redirectFromSignup',
            JSON.stringify(appState.metadata)
        )
    }
    if (Object.hasOwn(appState, 'redirectFrom')) {
        const { redirectFrom } = appState
        let { pathname, search, hash } = redirectFrom
        const route = `${pathname}${search}${hash}`
        window.location.assign(route)
    }
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
    <Auth0Provider
        domain={APP_ENV.REACT_APP_AUTH0_DOMAIN}
        clientId={APP_ENV.REACT_APP_AUTH0_CLIENTID}
        authorizationParams={{
            redirect_uri: window.location.origin + '/',
            audience: APP_ENV.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email',
        }}
        onRedirectCallback={onRedirectCallback}
        useRefreshTokens={true}
        cacheLocation="localstorage"
    >
        <App_v2 />
    </Auth0Provider>
)
